/**
 * sessionStorageに保存している配列の初期値を返す
 * @param id セッションストレージにキャッシュしている値を取り出すためのルームID
 * @returns キャッシュがあればその配列を、なければ空の配列を返す
 */
export const initList = (id: string, type: string): string[] => {
  let cachedIdList = sessionStorage.getItem(`${type}${id}`);

  if (!cachedIdList) return [];
  if (cachedIdList === 'undefined') return [];
  if (cachedIdList === 'null') return [];

  return JSON.parse(cachedIdList);
};

/**
 * sessionStorageに保存しているオブジェクトの初期値を返す
 * @param id セッションストレージにキャッシュしている値を取り出すためのルームID
 * @returns キャッシュがあればそのオブジェクトを、なければ空のオブジェクトを返す
 */
export const initObj = (id: string, type: string) => {
  interface StringKeyObject {
    [key: string]: any;
  }
  let cachedObj = sessionStorage.getItem(`${type}${id}`);
  if (!cachedObj) return {};
  if (cachedObj === 'undefined') return {};
  if (cachedObj === 'null') return {};

  return JSON.parse(cachedObj) as StringKeyObject;
};

/**
 * 前回のDB読み取り時刻を返す
 * @param id セッションストレージにキャッシュしている値を取り出すためのルームID
 * @returns 前回取得時刻orリクエスト時の日付
 */
export const initLastFetchDate = (id: string, type: string) => {
  const beforeLaunchDate = new Date();
  let cachedLastFetchDate = sessionStorage.getItem(`${type}${id}`);
  if (!cachedLastFetchDate) return beforeLaunchDate;
  if (cachedLastFetchDate === 'undefined') return beforeLaunchDate;
  if (cachedLastFetchDate === 'null') return beforeLaunchDate;

  return new Date(cachedLastFetchDate);
};
